import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  forwardRef,
  Injector,
} from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { nextTick } from 'process';

import { TranslateService } from '@ngx-translate/core';
import { AutoLog } from '../../../common/public-api';
import { TranslatableDropdownOption } from '../../../core/models';
import { BaseComponent } from '../../../shared/components';

export const RADIO_BUTTON_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => InputRadioButtonComponent),
  multi: true,
};

/**
 * RadioButton元件
 * @export
 * @class InputRadioButtonComponent
 * @implements {OnChanges}
 * @implements {OnInit}
 * @implements {ControlValueAccessor}
 */
@Component({
  selector: 'sigv-input-radio-button',
  templateUrl: './input-radio-button.component.html',
  styleUrls: ['./input-radio-button.component.css'],
  providers: [RADIO_BUTTON_VALUE_ACCESSOR],
})
export class InputRadioButtonComponent extends BaseComponent implements OnInit, ControlValueAccessor {
  /** 如有設定則會顯示於 formValidate時的錯誤訊息 */
  @Input() fieldName?: string;
  /** 欲綁定formControl欄位名稱
   * @description useForm.controls['externalName']
   */
  @Input() bindingFormControl?: AbstractControl | any;
  /** FormControllName */
  @Input() formControlName: string = 'radioBtnFormCtrl';
  /** 下拉選單選項 */
  @Input() selectOptions: TranslatableDropdownOption[] | SelectItem[] = [];
  /** 頁面是否純檢視*/
  @Input() isReadOnly: boolean = false;
  /** 選項是否垂直顯示 */
  @Input() isVertical: boolean = false;
  /** Click 事件 */
  @Output() clicked = new EventEmitter<any>();
  @Output() clickedValue = new EventEmitter<any>();
  /** Focus 事件 */
  @Output() focused = new EventEmitter<any>();
  /** Blur 事件 */
  @Output() blurred = new EventEmitter<any>();

  model?: string | boolean;
  onModelChange = (event: string | boolean | undefined) => {};
  onModelTouched = () => {};

  constructor(
    injector: Injector,
    private cdr: ChangeDetectorRef,
  ) {
    super(injector);
  }

  onClickEvent(event: any, value: any): void {
    this.logger.debug(
      'input-radio-button bindingFormControl ',
      this.bindingFormControl
    );
    this.updateModel(value);
    this.bindingFormControl.setValue(value);
    this.clicked.emit(event);
    this.clickedValue.emit(value);
  }

  render = true;
  forceRender() {
    this.render = false;
    nextTick(() => {
      this.render = true;
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isReadOnly'] || !changes['isReadOnly']) {
      this.forceRender();
    }
  }

  //#region Angular lifecycle hooks
  ngOnInit() {
    this.logger.debug('input-radio-button init');
    this.translateService.onLangChange.subscribe({
      next: (event: any) => {
        this.logger.debug(
          'input-radio-button-translate',
          event,
          this.translateService.currentLang
        );
      },
    });
  }
  //#endregion Angular lifecycle hooks

  //#region ControlValueAccessor 實作
  @AutoLog()
  writeValue(obj: any): void {
    this.model = obj;
  }
  registerOnChange(fn: any): void {
    this.onModelChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onModelTouched = fn;
  }
  //#endregionControlValueAccessor 實作

  /**
   * 更新 model 值
   *
   * @private
   * @param {string | boolean} [value]
   * @memberof InputRadioButtonComponent
   */
  @AutoLog()
  private updateModel(value?: string | boolean): void {
    this.model = value;
    this.onModelChange(value);
    this.cdr.detectChanges();
  }
}
